<template>
  <div class="mobile-me-center">
    <div class="mobile-profile-hero">
      <div class="profile-inner">
        <el-avatar :size="64" :src="user ? user.avatarUrl : ''" class="m-avatar" />
        <div class="m-user-meta">
          <div class="m-username-row">
            <span class="m-name">{{ user ? user.screenName : '未登录用户' }}</span>
          </div>
          <span class="m-uid">ID: {{ user ? user.userId : '-' }}</span>
        </div>
      </div>
    </div>

    <div class="mobile-storage-card">
      <div class="s-header">
        <div class="s-title-box">
          <i class="el-icon-cloudy" />
          <span class="s-title">云存储空间</span>
        </div>
      </div>

      <div class="s-usage-display">
        <span class="num-used">{{ diskSpace.used }} GB</span>
        <span class="num-total">/ {{ diskSpace.total }} GB</span>
      </div>

      <div class="m-multi-progress">
        <div class="m-seg video" :style="{ width: diskSpace.videoPercent + '%' }" />
        <div class="m-seg photo" :style="{ width: diskSpace.photoPercent + '%' }" />
        <div class="m-seg audio" :style="{ width: diskSpace.audioPercent + '%' }" />
        <div class="m-seg other" :style="{ width: diskSpace.otherPercent + '%' }" />
      </div>

      <div class="m-legend-grid">
        <div class="l-item"><i class="dot-indicator is-video" />视频 ({{ diskSpace.videoPercent }}%)</div>
        <div class="l-item"><i class="dot-indicator is-photo" />照片 ({{ diskSpace.photoPercent }}%)</div>
        <div class="l-item"><i class="dot-indicator is-photo" />音频 ({{ diskSpace.audioPercent }}%)</div>
        <div class="l-item"><i class="dot-indicator is-other" />其他 ({{ diskSpace.otherPercent }}%)</div>
      </div>
    </div>

    <div class="mobile-menu-group">
      <div
        v-for="item in actionList"
        :key="item.title"
        class="mobile-menu-item"
        @click="handleAction(item)"
      >
        <div class="item-left-content">
          <div class="item-icon-wrapper" :style="{ background: item.color + '15' }">
            <i :class="item.icon" :style="{ color: item.color }" />
          </div>
          <div class="item-text-block">
            <span class="item-title">{{ item.title }}</span>
            <span class="item-desc">{{ item.desc }}</span>
          </div>
        </div>
        <i class="el-icon-arrow-right item-right-arrow" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DiskMeMobile',
  data() {
    return {
      user: null,
      diskSpace: {
        total: 6144,
        used: 120,
        videoPercent: 35,
        photoPercent: 25,
        audioPercent: 30,
        otherPercent: 10
      },
      actionList: [
        { title: '回收站', desc: '已删除文件保留 30 天', icon: 'el-icon-delete', color: '#f56c6c' },
        { title: '个人设置', desc: '修改头像、密码与偏好', icon: 'el-icon-setting', color: '#64748b', action: 'settings' }
      ]
    }
  },
  created() {
    this.user = this.$store.state.userInfo
  },
  methods: {
    handleAction(item) {
      this.$message.info(`导航至: ${item.title}`)
    }
  }
}
</script>

<style scoped>
.mobile-me-center {
  background-color: #f6f8fa;
  min-height: 100vh;
  padding: 12px 14px 40px 14px;
  box-sizing: border-box;
}

/* 沉浸式顶部个人信息名片 */
.mobile-profile-hero {
  position: relative;
  background: linear-gradient(135deg, #ffffff 0%, #f1f5f9 100%);
  padding: 20px 16px;
  border-radius: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 4px 14px rgba(0,0,0,0.02);
}

.profile-inner { display: flex; align-items: center; gap: 14px; }
.m-avatar { border: 2px solid #fff; box-shadow: 0 4px 10px rgba(0,0,0,0.05); }

.m-user-meta { display: flex; flex-direction: column; gap: 4px; }
.m-username-row { display: flex; align-items: center; gap: 8px; }
.m-name { font-size: 18px; font-weight: bold; color: #1e293b; }

.m-vip-badge {
  background: linear-gradient(90deg, #f59e0b, #d97706);
  color: #fff;
  font-size: 10px;
  padding: 1px 6px;
  border-radius: 10px;
  font-weight: bold;
}
.m-uid { font-size: 12px; color: #64748b; }
.m-edit-profile-btn { font-size: 12px; padding: 4px 0; }

/* 存储卡片全面松绑 */
.mobile-storage-card {
  background: #fff;
  border-radius: 16px;
  margin-top: 12px;
  padding: 16px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.01);
}

.s-header { display: flex; justify-content: space-between; align-items: center; }
.s-title-box { display: flex; align-items: center; gap: 6px; font-weight: bold; color: #334155; font-size: 14px; }
.s-title-box i { color: #1a73e8; font-size: 16px; }
.s-action { font-size: 12px; color: #1a73e8; font-weight: 600; }

.s-usage-display { margin: 14px 0 10px 0; }
.num-used { font-size: 26px; font-weight: 800; color: #1a73e8; }
.num-total { font-size: 14px; color: #94a3b8; margin-left: 4px; }

.m-multi-progress {
  height: 8px;
  background: #f1f5f9;
  border-radius: 4px;
  display: flex;
  overflow: hidden;
}
.m-seg { height: 100%; }
.m-seg.video { background: #1989fa; }
.m-seg.photo { background: #67c23a; }
.m-seg.audio { background: #3ac2a7; }
.m-seg.other { background: #ff976a; }

.m-legend-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  margin-top: 14px;
}
.l-item { display: flex; align-items: center; font-size: 11px; color: #64748b; gap: 4px; }
.dot-indicator { width: 6px; height: 6px; border-radius: 50%; display: inline-block; }
.dot-indicator.is-video { background: #1989fa; }
.dot-indicator.is-photo { background: #67c23a; }
.dot-indicator.is-other { background: #ff976a; }

/* 微信式一列菜单项流 */
.mobile-menu-group {
  margin-top: 14px;
  background: #fff;
  border-radius: 16px;
  padding: 4px 0;
  display: flex;
  flex-direction: column;
}

.mobile-menu-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 16px;
  transition: background 0.1s;
  -webkit-tap-highlight-color: transparent;
}
.mobile-menu-item:not(:last-child) { border-bottom: 1px solid #f1f5f9; }
.mobile-menu-item:active { background: #f8fafc; }

.item-left-content { display: flex; align-items: center; gap: 14px; flex: 1; overflow: hidden; }

.item-icon-wrapper {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  flex-shrink: 0;
}

.item-text-block { display: flex; flex-direction: column; gap: 2px; overflow: hidden; }
.item-title { font-size: 14px; font-weight: 600; color: #1e293b; }
.item-desc { font-size: 11px; color: #94a3b8; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.item-right-arrow { color: #cbd5e1; font-size: 14px; }

/* 移动端设置弹窗列表重塑 */
::v-deep .mobile-popup-settings {
  border-radius: 16px !important;
}
::v-deep .mobile-popup-settings .el-dialog__body {
  padding: 10px 20px 20px 20px;
}
.mobile-form-list { display: flex; flex-direction: column; }
.form-row { display: flex; justify-content: space-between; align-items: center; padding: 10px 0; }
.f-label { font-size: 14px; font-weight: 600; color: #334155; }
.v-tag { font-family: monospace; font-size: 13px; color: #64748b; }
.m-divider { margin: 4px 0 !important; }
.dialog-footer-full { padding-top: 10px; }
</style>
